// extracted by mini-css-extract-plugin
module.exports = {"socialIcons":"SocialIcons_socialIcons__XzLww","socialIconLink":"SocialIcons_socialIconLink__1VoEL","tile":"SocialIcons_tile__eewmP"};